import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import Icons from "../../../../../../Config/Images";
import "./FilterModal.css";

const FilterModal = ({
  closeModal,
  position,
  selectedDate1,
  selectedDate2,
  setSelectedDate1,
  setSelectedDate2,
  onApply,
}) => {
  const modalRef = useRef(null);

  const [isCalendarOpen1, setIsCalendarOpen1] = useState(false);
  const [isCalendarOpen2, setIsCalendarOpen2] = useState(false);

  // Close calendar on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsCalendarOpen1(false);
        setIsCalendarOpen2(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div
      className="filter-modal-overlay"
      style={{
        top: position.top,
        left: position.left,
        position: "absolute",
      }}
    >
      <div className="filter-modal" ref={modalRef}>
        <div className="modal-header">
          <p className="filter-head-para">Filter by</p>
        </div>
        {/* <hr  style={{height:"1px"}}/> */}
        <div style={{height:"1px", backgroundColor:"#111111", marginTop:"4px"}}/>
        <div className="modal-body">
          <p className="date-range-para">Date Range</p>
          <div className="dates-div">
            {/* From Date */}
            <div className="select-date">
              <p>
                {selectedDate1 ? selectedDate1.toLocaleDateString() : "From"}
              </p>
              <img
                src={Icons.date_picker_icon}
                alt="Date Picker"
                onClick={() => setIsCalendarOpen1((prev) => !prev)}
              />
              {isCalendarOpen1 && (
                <div className="calendar-popup">
                  <Calendar
                    value={selectedDate1}
                    onChange={(date) => {
                      setSelectedDate1(date);
                      setIsCalendarOpen1(false);
                    }}
                    maxDate={new Date()}
                  />
                </div>
              )}
            </div>

            {/* To Date */}
            <div className="select-date">
              <p>{selectedDate2 ? selectedDate2.toLocaleDateString() : "To"}</p>
              <img
                src={Icons.date_picker_icon}
                alt="Date Picker"
                onClick={() => setIsCalendarOpen2((prev) => !prev)}
              />
              {isCalendarOpen2 && (
                <div className="calendar-popup">
                  <Calendar
                    value={selectedDate2}
                    onChange={(date) => {
                      setSelectedDate2(date);
                      setIsCalendarOpen2(false);
                    }}
                    maxDate={new Date()}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="modal-actions">
            <button
              className="apply-btn"
              onClick={() => {
                onApply();
                closeModal();
              }}
            >
              Apply
            </button>
            <button
              className="reset-btn"
              // onClick={() => {
              //   setSelectedDate1(null);
              //   setSelectedDate2(null);
              //   onApply();
              //   closeModal();
              // }}
              onClick={() => {
                // Reset state
                setSelectedDate1(null);
                setSelectedDate2(null);

                // Call onApply with explicit nulls
                onApply(null, null);

                closeModal();
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
